import React, { ButtonHTMLAttributes, FC } from 'react'
import LoadingIndicator from './LoadingIndicator'

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: 'primary' | 'secondary' | 'outline' | 'outline-brand' | 'danger'
  isLoading?: boolean
  replaceChildrenWhileLoading?: boolean
}

const Button: FC<Props> = ({
  children,
  variant = 'primary',
  isLoading,
  disabled,
  className,
  replaceChildrenWhileLoading = false,
  ...rest
}) => (
  <button
    className={`${baseStyles} ${disabled || isLoading ? 'cursor-not-allowed opacity-50' : interactiveStyles} ${styles[variant]} ${className}`}
    disabled={disabled || isLoading}
    {...rest}
  >
    {isLoading
      ? (
        <div className='relative flex flex-1 items-center justify-center'>
          {replaceChildrenWhileLoading
            ? (
              <div
                className={`${textStyles[variant]} flex w-20 items-center justify-center`}
              >
                <LoadingIndicator className={textStyles[variant]}/>
              </div>
            )
            : (
              <>
                <div className={`${textStyles[variant]} absolute left-4`}>
                  <LoadingIndicator className={textStyles[variant]}/>
                </div>

                <div className={`${textStyles[variant]}`}>{children}</div>

                <div></div>
              </>
            )}
        </div>
      )
      : (
        <>{children}</>
      )}
  </button>
)

const styles = {
  primary: 'primary-btn',
  secondary: 'secondary-btn',
  outline: 'outline-btn',
  'outline-brand': 'outline-brand-btn',
  danger: 'danger-btn'
}

const textStyles = {
  primary: 'text-action-primary-foreground',
  secondary: 'text-action-secondary-foreground',
  outline: 'text-action-outline-foreground',
  'outline-brand': 'text-text-brand',
  danger: 'text-action-destructive-foreground'
}

const baseStyles = 'min-w-fit rounded-md'
const interactiveStyles = 'hover:bg-opacity-90'

export default Button
